import {v4 as uuidv4} from "uuid";
import firestore      from "@/firebase/async-firestore";
import firebase       from "firebase";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import {isNil}        from "lodash";
import moment         from "moment";
import GenericDB      from "./generic-db";

export default class DemandsDb extends GenericDB {
    constructor() {
        super("demands");
    }

    /**
     * Create a document in the collection
     * @param data
     * @param id
     */
    async create(data, id = null) {
        const collectionRef   = (await firestore()).collection(this.collectionPath);
        const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();

        const dataToCreate = {
            ...data,
            createTimestamp: serverTimestamp,
            updateTimestamp: serverTimestamp,
            hidden         : 1
        };

        if (isNil(id)) {
            id = uuidv4();
        }

        let response = {};
        try {
            const docId = await collectionRef
                .doc(id)
                .set(dataToCreate)
                .then(() => id)
                .catch(() => {
                });

            response = {
                id: docId,
                ...data,
                createTimestamp: new Date(),
                updateTimestamp: new Date()
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }

        const notifyAllMembers = firebase.functions().httpsCallable("notifyAllMembers");
        try {
            await notifyAllMembers(response);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log("Remote Function Error: ", e);
        }

        return response;
    }

    async getDemandsWithDateDescendant(withHidden) {
        const collectionRef = (await firestore()).collection(this.collectionPath);

        try {
            const formatResult = result =>
                result.docs.map(
                    ref => this.convertObjectTimestampPropertiesToDate(
                        {
                            id: ref.id,
                            ...ref.data()
                        }
                    )
                );

            // The hidden value getting the following two values:
            //  1: The demand it is not hidden. (Default State)
            //  2: The demand it is hidden.
            return collectionRef
                .where("hidden", "<=", withHidden ? 2 : 1)
                .get()
                .then(formatResult)
                .catch(() => {
                });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e.message);
        }

        return false;
    }

    async updateAuthorLastInteractionTimestamp(demandID) {
        (await firestore())
            .collection(this.collectionPath)
            .doc(demandID)
            .update(
                {
                    authorLastInteraction: moment().unix()
                }
            );
    }

    async getSingleDemand(demandID) {
        (await firestore())
            .collection(this.collectionPath)
            .doc(demandID);
    }

    // eslint-disable-next-line class-methods-use-this
    async hideOldDemands() {
        const x = new Date();
        x.setDate(x.getDate() - 30);
        const firebaseXDay = firebase.firestore.Timestamp.fromDate(x);

        const collection = await (await firestore())
            .collection(this.collectionPath)
            .where("updateTimestamp", "<", firebaseXDay)
            .get();

        const batch = firebase.firestore().batch();
        collection.forEach(
            doc => {
                const docRef = firebase.firestore().collection("demands").doc(doc.id);
                batch.update(docRef, {hidden: 2});
            }
        );
        batch.commit();
    }
}
